import React from 'react';
import cx from 'classnames';
import styles from './LaunchPad.module.scss';

const LeftArrowIcon = () => {
    return (
        <div className={cx(styles['icon'], styles['baseline'])}>
            <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M0.75 12H23.25"
                    stroke="#FB625B"
                    stroke-width="3"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <path
                    d="M12.75 22.5L23.25 12L12.75 1.5"
                    stroke="#FB625B"
                    stroke-width="3"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </div>
    );
};

export default LeftArrowIcon;
